import { useEffect, useState } from 'react'
import { t } from '@/lib/i18n'
import { fmt } from '@/lib/utils'
import { useKioskStore } from '@/stores/kiosk-store'

const DEFAULT_AUTO_DISMISS_SECONDS = 30

export default function ReceiptScreen() {
  const completedOrder = useKioskStore((s) => s.completedOrder)
  const receiptHtml = useKioskStore((s) => s.receiptHtml)
  const locale = useKioskStore((s) => s.locale)
  const resetToAttractor = useKioskStore((s) => s.resetToAttractor)
  const resetForNewOrder = useKioskStore((s) => s.resetForNewOrder)
  const remoteConfig = useKioskStore((s) => s.remoteConfig)

  const autoDismissSeconds = remoteConfig?.receiptAutoDismiss ?? DEFAULT_AUTO_DISMISS_SECONDS
  const [countdown, setCountdown] = useState(autoDismissSeconds)

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          resetToAttractor()
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [resetToAttractor])

  const isLandscape = remoteConfig?.layoutMode === 'landscape'

  return (
    <div className="h-full w-full flex flex-col items-center bg-kiosk-bg">
      <div className={`w-full flex flex-col h-full ${isLandscape ? 'max-w-3xl' : 'max-w-lg'}`}>
        <div className="flex-1 overflow-y-auto kiosk-scroll px-6 py-8">
          <div className="w-full max-w-md mx-auto space-y-5">
            {/* Success header */}
            <div className="bg-kiosk-surface rounded-2xl p-8 text-center space-y-4">
              <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto">
                <svg className="h-10 w-10 text-green-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-kiosk-accent">Tack f&ouml;r din best&auml;llning!</h2>
              <p className="text-kiosk-muted text-lg">{completedOrder?.type === 'EatIn' ? 'Din mat förbereds och serveras snart' : 'Din mat förbereds för avhämtning'}</p>
            </div>

            {/* Order summary */}
            {completedOrder && completedOrder.items.length > 0 && (
              <div className="bg-kiosk-surface rounded-2xl p-5 space-y-3">
                {completedOrder.items.map((item, i) => (
                  <div key={i} className="flex justify-between">
                    <span className="text-kiosk-text">
                      {item.count}x {item.name}
                    </span>
                    <span className="text-kiosk-accent font-semibold">{fmt(item.price * item.count)}</span>
                  </div>
                ))}
                <div className="border-t border-kiosk-surface-2 pt-3 flex justify-between">
                  <span className="text-kiosk-text font-bold text-lg">{t('cart.total', locale)}</span>
                  <span className="text-kiosk-accent font-bold text-lg">{fmt(completedOrder.total)}</span>
                </div>
              </div>
            )}

            {/* Receipt HTML */}
            {receiptHtml && (
              <div className="bg-white rounded-2xl p-4">
                <iframe srcDoc={receiptHtml} className="w-full min-h-75 border-none" title="Kvitto" />
              </div>
            )}
          </div>
        </div>

        {/* Bottom actions */}
        <div className="shrink-0 px-6 pb-8 pt-4 bg-kiosk-surface border-t border-kiosk-surface-2 space-y-3">
          <button onClick={resetForNewOrder} className="kiosk-btn w-full py-5 bg-kiosk-accent text-kiosk-bg font-bold rounded-2xl text-xl">
            Ny best&auml;llning
          </button>
          <p className="text-kiosk-muted text-sm text-center">&Aring;terg&aring;r automatiskt om {countdown} sek</p>
        </div>
      </div>
      {/* max-w-lg */}
    </div>
  )
}
